import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  deleteDocumentAPICall,
  stageDetailsAPICall,
  uploadDocumentsAPICall,
  uploadDpdetailsAPICall,
} from "./APICallsAccountClosure";
import keyboardicon from "../../Components/assets/Images/panicongrey.svg";
import uploadStyles from "./AccountClosureCMRUpload.module.scss";
import SnackBar from "../../Components/SnackBars/SnackBar";
import SucessSnackBar from "../../Components/SnackBars/SucesssnackBar";
import csvimage from "../../Components/assets/Images/csvimage.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDropzone } from "react-dropzone";
import Delete from "@mui/icons-material/Delete";
import ReactCropper from "../Finupdate/ReactCropper/ReactCropper";
import PreviewModalPopup from "../Finupdate/PreviewModalPopup";
import PdfModal from "../Finupdate/PdfModal/PdfModal";
import ClearIcon from "@mui/icons-material/Clear";
import viewImage from "../../Components/assets/Images/view-alt-svgrepo-com 1.svg";
import featherUpload from "../../Components/assets/Images/feather_upload-cloud.svg";
import { dataURItoFile } from "../../shared/commonfunctions";
import { getCookie } from "../Finupdate/cookies";
import { confirmAlert } from "react-confirm-alert";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import BackDrop from "../../Components/BackDrop";
import routesData from "../../shared/routes.json";
import Dropdown from "../../Components/SelectDropdown/DropDown";
import FormatterCheckerAccountClosure from "./AccountClosureFormatChecker";
import sigicon from "../../Components/assets/Images/sigicon.svg";

const optionsdata = [
  {
    id: "NSDL",
    sequence: 1,
    value: "NSDL",
  },
  {
    id: "CDSL",
    sequence: 2,
    value: "CDSL",
  },
];

export default function AccountClosureCMRUpload() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [submitloading, setsubmitloading] = useState(false);
  const [completedStages, setcompletedStages] = useState(50);
  const [uploadloading, setuploadloading] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [disableUpload, setdisableUpload] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [doneImagePreview, setDoneImagePreview] = useState(false);
  const [image, setImage] = useState<any>();
  const [showPreviewModal, setshowPreviewModal] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [displayFile, setDisplayFile] = useState({
    status: false,
    type: "",
  });
  const [deleteloading, setDeleteLoading] = useState(false);
  const [disableContinueOption1, setdisableContinueOption1] = useState("");
  const [fileUploadedStatus, setFileUploadedStatus] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [clientdpid, setclientdpid] = useState("");
  const [targetdpid, settargetdpid] = useState("");
  const [selectedOption, setSelectedOption] = useState<any>("");
  const [autofocus, setautofocus] = useState(false);
  const maxSize = 10 * 1024 * 1024;

  const formats: any = ["pdf"];
  const requestID: any = sessionStorage.getItem("acrequestID");

  useEffect(() => {
    window.scrollTo(0, 0);
    StageDetails();
  }, []);

  useEffect(() => {
    if (targetdpid === "" && selectedOption?.id === "NSDL") {
      settargetdpid("IN");
    }
  }, [targetdpid, selectedOption]);

  const SubmitDetails = () => {
    let obj: any = {
      request_id: requestID,
      // dp_id: targetdpid.toUpperCase(),
      // client_code: clientdpid.toUpperCase(),
      // account_type: selectedOption.id,
    };
    setsubmitloading(true);
    uploadDpdetailsAPICall(obj)
      .then((response: any) => {
        //console.log("response", response);
        setsubmitloading(false);
        navigate("/account_closure/esign");
      })
      .catch((error: any) => {
        //  console.log("error", error);
        setsubmitloading(false);
        if (error.response.data.message) {
          seterrorMessage(error.response.data.message);
          setTimeout(() => {
            seterrorMessage("");
          }, 3000);
        }
      });
  };

  const StageDetails = () => {
    let obj: any = {
      stage: "cmr_upload",
      request_id: requestID,
    };

    setloading(true);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("response.data.data.url", response.data.data);
        setloading(false);
        if (response.data.data.url !== "") {
          setSelectedFile(response.data.data.url);
          setImage(response.data.data.url);
          setFileUploadedStatus(true);
          setdisableContinueOption1("Successfully uploaded the document.");
          setDisplayFile({
            status: true,
            type: response.data.data.doc_type_ref,
          });
        } else {
          setFileUploadedStatus(false);
          setDisplayFile({
            status: false,
            type: "",
          });
        }
        if (response.data.data.transfer_dp_details.dp_id) {
          settargetdpid(response.data.data.transfer_dp_details.dp_id);
        }
        if (response.data.data.transfer_dp_details.client_code) {
          setclientdpid(response.data.data.transfer_dp_details.client_code);
        }
        if (response.data.data.transfer_dp_details.account_type) {
          const filteredData = optionsdata.filter(
            (a: any) =>
              a.id === response.data.data.transfer_dp_details.account_type
          );
          setSelectedOption(filteredData[0]);
        }

        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handleChangeSelectDepositories = (event: any) => {
    setSelectedOption(event.target.value);
    if (event.target.value === "NSDL") {
      settargetdpid("IN");
      setautofocus(true);
    } else {
      settargetdpid("");
      setautofocus(true);
    }
  };

  const handleDocumentID = (uplaoddata: any) => {
    setSuccessMessage(uplaoddata);
    setdisableContinueOption1(uplaoddata);
  };

  return (
    <div className={uploadStyles.mainWrapperTop}>
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <SucessSnackBar message={successMessage} />

      {loading && <BackDrop />}

      <div className={uploadStyles.wrapper}>
        <div className={uploadStyles.step}>
          <img src={keyboardicon} /> Step 3 of 4
        </div>
        <div className={uploadStyles.headerSection}>
          <p className={uploadStyles.signup}>Upload CMR Details</p>
          <p className={uploadStyles.messageSection}>
            To proceed, please upload a clear copy of your CMR document for
            verification.
          </p>
        </div>
        <div className={uploadStyles.contentWrapper}>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={{ xs: 1, sm: 2, md: 5 }}
          >
            {/* <Grid item xs={12} sm={6}>
              <Dropdown
                LabelName={"Select Depositories"}
                menuItems={optionsdata}
                name={"Select Depositories"}
                value={selectedOption}
                handleChange={handleChangeSelectDepositories}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Enter DP ID"
                id="outlined-size-small"
                variant="outlined"
                autoFocus={autofocus}
                value={targetdpid}
                fullWidth
                //   onChange={handleEmailName}
                disabled={selectedOption === ""}
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
                onKeyPress={(event) => {
                  const keyCode = event.keyCode || event.which;
                  const keyValue = String.fromCharCode(keyCode);
                  const isValidKey = /^\d+$/.test(keyValue);

                  if (!isValidKey) {
                    event.preventDefault();
                  }
                }}
                onChange={(event: any) =>
                  settargetdpid(event.target.value.toUpperCase())
                }
              />
              <FormHelperText sx={{ color: "red", textAlign: "center" }}>
                {targetdpid.length > 2 &&
                  targetdpid.length < 8 &&
                  "Min and Max Limit 8 digits"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Target DP Client ID"
                id="outlined-size-small"
                variant="outlined"
                value={clientdpid}
                fullWidth
                disabled={selectedOption === ""}
                onChange={(event: any) =>
                  setclientdpid(event.target.value.toUpperCase())
                }
                inputProps={{
                  sx: {
                    "&::label": {
                      fill: "#111827",
                      fontWeight: 500,
                    },
                    color: "var(--Black-Black-500, #6B7280)",
                    fontSize: "14px",
                  },
                  maxLength: 50,
                  inputMode: "text",
                }}
                sx={{
                  fieldset: {
                    borderColor: "#E5E7EB",
                    borderRadius: "100px",
                    height: "60px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "#6B7280",
                    fontWeight: 500,
                    "&.MuiFormLabel-filled": {
                      color: "#111827", // Label color when the field has a value
                    },
                  },
                }}
                onKeyPress={(event) => {
                  const keyCode = event.keyCode || event.which;
                  const keyValue = String.fromCharCode(keyCode);
                  const isValidKey = /^\d+$/.test(keyValue);

                  if (!isValidKey) {
                    event.preventDefault();
                  }
                }}
              />
              <FormHelperText sx={{ color: "red", textAlign: "center" }}>
                {clientdpid.length > 1 &&
                  clientdpid.length < 8 &&
                  "Min and Max Limit 8 digits"}
              </FormHelperText>
            </Grid> */}
            <Grid item xs={12} sm={12}>
              <div className={uploadStyles.uploadSignatureSection}>
                <div className={uploadStyles.label}>
                  <img src={sigicon} /> CMR Copy{" "}
                </div>
                <div>
                  <p className={uploadStyles.subText}> CMR </p>
                </div>
                <div>
                  <FormatterCheckerAccountClosure
                    acceptedFormats={formats}
                    previewImage={() => {}}
                    documentRef={""}
                    documentID={handleDocumentID}
                    displayOptions={undefined}
                    stageDetailsData={selectedFile}
                    name={""}
                    purpose={""}
                    pdfSize={3}
                    imageSize={3}
                  />
                </div>
              </div>
            </Grid>
          </Grid>

          <div className={uploadStyles.buttonStack}>
            <LoadingButton
              variant="contained"
              onClick={SubmitDetails}
              loading={submitloading}
              sx={{ height: "50px" }}
              id="upLoadDocumentsContinueButton"
              className={uploadStyles.approveButton}
              disabled={disableContinueOption1 === ""}
              // disabled={
              //   disableContinueOption1 === "" ||
              //   clientdpid === "" ||
              //   targetdpid === "" ||
              //   targetdpid.length !== 8 ||
              //   selectedOption === ""
              // }
            >
              {" "}
              Submit
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
}
